export default "__VITE_ASSET__Bbq4ksPN__"